import React from "react";
import {
  HardHat,
  Microscope,
  CheckCircle,
  ArrowRight,
  Building2,
  Cpu,
} from "lucide-react";

const SubsidiaryEcosystem = () => {
  const subsidiaries = [
    {
      name: "Focus Inspection Technology",
      tagline: "Field Inspection & Industrial NDT Services",
      type: "Execution Division",
      headquarters: "India • Middle East • Offshore Support",

      description:
        "Focus Inspection Technology is the operational backbone of the group, delivering advanced non-destructive testing, welding inspection, and shutdown support for shipyard, oil & gas, fabrication, and heavy engineering industries. Our teams operate with certified procedures, calibrated equipment, and strict quality compliance to ensure safety and reliability of critical assets.",

      capabilities:
        "Specialized in PAUT, TOFD, UT, MT, PT, VT, and custom inspection solutions for pipelines, pressure vessels, offshore structures, and complex weld geometry.",

      link: "https://focusinspectiontechnology.com",

      icon: <HardHat className="w-7 h-7" />,

      image:
        "https://focusinspectiontechnology.com/static/media/g3.78a1bdf59df06d3fba3a.jpeg",

      features: [
        "ISO / ASNT Certified Inspectors",
        "Advanced PAUT & TOFD",
        "Shutdown & Offshore Support",
        "Custom Scanner Solutions",
        "24/7 Field Deployment",
        "Industrial Compliance",
      ],
    },

    {
      name: "Focus NDT Innovations",
      tagline: "Software, Automation & NDT 4.0 Systems",
      type: "Technology Division",
      headquarters: "Software Lab • Cloud Systems • R&D",

      description:
        "Focus NDT Innovations is the technology arm of the group focused on digital inspection platforms, AI-assisted reporting, and cloud-based NDT management systems. The division develops tools that reduce human error, improve traceability, and automate inspection workflows for modern industrial environments.",

      capabilities:
        "Development of inspection software, reporting automation, scanner integration, AI analysis tools, and cloud inspection logs designed for real-world NDT operations.",

      link: "https://focusin360.com",

      icon: <Cpu className="w-7 h-7" />,

      image:
        "https://focusinspectiontechnology.com/static/media/g21.f367a6d99862ff43f808.jpeg",

      features: [
        "Inspection Software",
        "AI Report Automation",
        "Cloud Data Logs",
        "Scanner Integration",
        "Custom Engineering Tools",
        "NDT 4.0 Systems",
      ],
    },
  ];

  return (
    <section
      id="ecosystem"
      className="py-20 md:py-32 px-4 sm:px-6 bg-slate-900 text-white"
    >
      <div className="max-w-6xl mx-auto">

        {/* HEADER */}

        <div className="mb-16 md:mb-24">

          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-orange-600" />
            <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">
              Group Structure
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-6xl font-black">
            Focus Group Ecosystem
          </h2>

          <p className="text-slate-400 mt-4 max-w-xl text-sm">
            The Focus Group operates through specialized divisions combining
            field inspection expertise with modern software development to
            deliver complete NDT and engineering solutions.
          </p>

        </div>



        {/* DIVISIONS */}

        <div className="space-y-24">

          {subsidiaries.map((comp, idx) => (

            <div
              key={idx}
              className={`flex flex-col ${
                idx % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
              } gap-10 items-center`}
            >

              {/* IMAGE */}

              <div className="lg:w-1/2">

                <div className="rounded-xl overflow-hidden border border-white/10">

                  <img
                    src={comp.image}
                    alt={comp.name}
                    className="w-full h-[260px] md:h-[420px] object-cover"
                  />

                </div>

              </div>



              {/* CONTENT */}

              <div className="lg:w-1/2 space-y-6">

                <div className="flex items-center gap-3">

                  <div className="p-3 bg-orange-600">
                    {comp.icon}
                  </div>

                  <div>

                    <p className="text-xs text-orange-500 uppercase font-bold tracking-wider">
                      {comp.type}
                    </p>

                    <p className="text-xs text-slate-500">
                      {comp.headquarters}
                    </p>

                  </div>

                </div>


                <h3 className="text-2xl md:text-4xl font-black">
                  {comp.name}
                </h3>


                <p className="text-orange-500 text-xs uppercase tracking-widest font-bold">
                  {comp.tagline}
                </p>


                <p className="text-slate-400 text-sm leading-relaxed">
                  {comp.description}
                </p>


                <p className="text-slate-500 text-sm italic">
                  {comp.capabilities}
                </p>



                {/* FEATURES */}

                <div className="grid grid-cols-2 gap-3">

                  {comp.features.map((f) => (

                    <div
                      key={f}
                      className="flex items-center gap-2 text-xs text-slate-300"
                    >
                      <CheckCircle className="w-4 h-4 text-orange-500" />
                      {f}
                    </div>

                  ))}

                </div>



                {/* BUTTON */}

                <a
                  href={comp.link}
                  className="inline-flex items-center gap-2 mt-4 bg-white text-black px-6 py-3 text-xs font-bold uppercase tracking-widest hover:bg-orange-600 hover:text-white transition"
                >
                  Visit Division
                  <ArrowRight size={14} />
                </a>

              </div>

            </div>

          ))}

        </div>



        {/* FOOT NOTE */}

        <div className="mt-20 text-center">

          <p className="text-slate-500 text-xs uppercase tracking-widest">
            Focus NDT Group • Inspection • Engineering • Software • Automation
          </p>

        </div>

      </div>
    </section>
  );
};

export default SubsidiaryEcosystem;